import { useRef, useEffect } from 'react';

const isBrowser = typeof window !== `undefined`;

export interface IScrollPosition {
  x: number;
  y: number;
}
export function getScrollPosition({
  element,
  useWindow,
}: {
  element: any;
  useWindow: boolean;
}): IScrollPosition {
  if (!isBrowser) {
    return { x: 0, y: 0 };
  }

  const target = element ? element.current : document.body;
  const position = target.getBoundingClientRect();

  return useWindow
    ? { x: window.pageXOffset, y: window.pageYOffset }
    : { x: position.left, y: position.top };
}

export function getWindowWidth(): number | null {
  if (!isBrowser) {
    return null;
  }

  return window.innerWidth;
}
export function useScrollPosition(
  effect: any,
  deps: any,
  element: any,
  useWindow: boolean,
  wait: any
): void {
  const position = useRef(getScrollPosition({ element, useWindow }));

  let throttleTimeout: any = null;

  const callBack = () => {
    const currPos = getScrollPosition({ element, useWindow });
    effect({ prevPos: position.current, currPos });
    position.current = currPos;
    throttleTimeout = null;
  };

  useEffect(() => {
    if (!isBrowser) {
      return;
    }

    const handleScroll = () => {
      if (wait) {
        if (throttleTimeout === null) {
          throttleTimeout = setTimeout(callBack, wait);
        }
      } else {
        callBack();
      }
    };

    // sets scroll position on render to handle wonky navbar when pressing back button
    handleScroll();

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, deps);
}

useScrollPosition.defaultProps = {
  deps: [],
  element: false,
  useWindow: false,
  wait: null,
};
